import { inject, Injectable } from '@angular/core';

import type { CommonEnvironment } from '@core/common-legacy';
import { AUTH_TOKEN, COMPANY_ID } from '@core/common-legacy';

export abstract class IntegrationsClientConfig {
  public environmentName: CommonEnvironment['environmentName'];
  public apiUrl: string;
  public integrationsUrl: string;
  public hasCheckrTestQueryParam: boolean;
  public isE2e: boolean;
}

export interface IntegrationsEnvironment {
  integrations: {
    integrationsUrl: string;
    hasCheckrTestQueryParam: boolean;
  };
}

export const provideIntegrationsClientConfig = (config: IntegrationsClientConfig) => ({
  provide: IntegrationsClientConfig,
  useValue: config,
});

@Injectable({ providedIn: 'root' })
export class IntegrationsCredentials {
  public companyId: number = inject(COMPANY_ID, { optional: true })!;
  public accessToken: string = inject(AUTH_TOKEN, { optional: true })!;
}
